var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { getSmartApproachUrl } from '@/shared/utils/helpers';
let SmartApproachAppConfig = class SmartApproachAppConfig extends Vue {
    constructor() {
        super(...arguments);
        this.url = getSmartApproachUrl();
        this.onMessage = (event) => {
            if (!this.url || event.origin !== new URL(this.url).origin)
                return;
            if (!event.data || event.data.type !== 'READY')
                return;
            const iframe = this.$refs.iframe;
            if (!iframe || !iframe.contentWindow)
                return;
            const token = localStorage.getItem('auth_token_default') || '';
            const targetOrigin = new URL(this.url).origin;
            iframe.contentWindow.postMessage({ type: 'AUTH', token }, targetOrigin);
            const authUser = this.$auth.user();
            const email = authUser && authUser.email;
            if (email) {
                iframe.contentWindow.postMessage({ type: 'USER_ID', email }, targetOrigin);
            }
        };
    }
    mounted() {
        this.$gtag.pageview({ page_path: this.$route.path });
        window.addEventListener('message', this.onMessage);
    }
    beforeDestroy() {
        window.removeEventListener('message', this.onMessage);
    }
};
SmartApproachAppConfig = __decorate([
    Component({
        name: 'SmartApproachAppConfig',
    })
], SmartApproachAppConfig);
export default SmartApproachAppConfig;
